<template>
  <div class="comp-interactionbar">
    <component
      v-for="(comp, idx) in computedActions"
      :key="`comp-ib-${idx}`"
      :is="comp.type"
      v-bind="comp.props"
      @input="handleComponentInput(comp.id, $event)"
    />
  </div>
</template>

<script>
  export default {
    name: 'InteractionBar',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      actions: {
        type: Array,
        default: () => [],
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedActions() {
        const actions = this.actions || [];
        return actions.filter(a => a.comp !== null);
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleComponentInput(id, value) {
        this.$emit('interaction', { id, value });
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-interactionbar {
  padding: 14px 20px;
  display: inline-flex;
  column-gap: 20px;

  .input-text {
    & > div.icon, & > input[type=text], input[type=password] {
      border-color: $color-black-alpha-10;
    }
  }
}
</style>
